import { BrowserRouter, Route, Routes, useLocation, Navigate } from "react-router-dom";
import { Suspense, lazy } from "react";
import { Toaster } from "react-hot-toast";
import ScrollToTop from "./components/ScrollToTop"
import { SkeletonTheme } from "react-loading-skeleton";
import Payment from "./pages/Payment";
import WithdrawList from "./pages/WithdrawList";


// Lazy-loaded Components
const Header = lazy(() => import("./components/Header"));
const Footer = lazy(() => import("./components/Footer"));
const MobileNavbar = lazy(() => import("./components/MobileNavbar"));
const NotFound = lazy(() => import("./pages/NotFound"));
// Lazy-loaded Pages
const Home = lazy(() => import("./pages/Home"));
const Game = lazy(() => import("./pages/Game"));
const Blogs = lazy(() => import("./pages/Blogs"));
const Notification = lazy(() => import("./pages/Notification"));
const Support = lazy(() => import("./pages/Support"));
const AboutUs = lazy(() => import("./pages/AboutUs"));
const Blog = lazy(() => import("./pages/Blog"));
const Register = lazy(() => import("./pages/Register"));
const Login = lazy(() => import("./pages/Login"));
const ForgetPassword = lazy(() => import("./pages/ForgetPassword"));
const Dashboard = lazy(() => import("./pages/Dashboard"));
const Wallet = lazy(() => import("./pages/Wallet"));
const Clan = lazy(() => import("./pages/Clan"));
const Room = lazy(() => import("./pages/Room"));
const RoomResult = lazy(() => import("./pages/RoomResult"));
const NewMatch = lazy(() => import("./pages/NewMatch"));
const PopularMatch = lazy(() => import("./pages/PopularMatch"));
const CategoryRooms = lazy(() => import("./pages/CategoryRooms"));



const Leaderboard = lazy(() => import("./pages/Leaderboard"));
const SingleLeaderBoard = lazy(() => import("./pages/SingleLeaderBoard"));

// Loader
const Loader = () => (
    <div className="flex w-full items-center justify-center min-h-screen">
        <h1 className="load">
            <span className="let7">g</span>
            <span className="let6">n</span>
            <span className="let5">i</span>
            <span className="let4">d</span>
            <span className="let3">a</span>
            <span className="let2">o</span>
            <span className="let1">l</span>
        </h1>
    </div>
);

// ✅ Protected Route Component
const ProtectedRoute = ({ children }) => {
    const isAuthenticated = !!localStorage.getItem("access_token");
    return isAuthenticated ? children : <Navigate to="/login" replace />;
};

const AppContent = () => {
    const location = useLocation();

    return (
        <div className="flex flex-col min-h-screen">
            {/* Header */}
            <Header />

            {/* Main content */}
            <main className="flex-grow">
                <Toaster
                    position="top-center"
                    reverseOrder={false}
                    toastOptions={{
                        style: { fontSize: "13px" },
                    }}
                />

                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/games/:slug" element={<Game />} />
                    <Route path="/blogs" element={<Blogs />} />
                    <Route path="/blog/:slug" element={<Blog />} />
                    <Route path="/new-matches" element={<NewMatch />} />
                    <Route path="/popular-matches" element={<PopularMatch />} />
                    <Route path="/games/:slug/:name/:id" element={<CategoryRooms />} />
                    <Route path="*" element={<NotFound />} />

                    <Route
                        path="/notification"
                        element={
                            <ProtectedRoute>
                                <Notification />
                            </ProtectedRoute>
                        }
                    />
                    <Route path="/support" element={<Support />} />
                    <Route path="/about-us" element={<AboutUs />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/forget-password" element={<ForgetPassword />} />
                    <Route path="/leaderboard" element={<Leaderboard />} />
                    <Route path="/leaderboard/:slug" element={<SingleLeaderBoard />} />
                    <Route path="/payment/verify" element={<Payment />} />

                    <Route
                        path="/dashboard"
                        element={
                            <ProtectedRoute>
                                <Dashboard />
                            </ProtectedRoute>
                        }
                    />
                     <Route
                        path="/withdraw-list"
                        element={
                            <ProtectedRoute>
                                <WithdrawList />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/games/:slug/:id"
                        element={<Room />}
                    />

                    <Route
                        path="/games/:slug/:id/result"
                        element={
                            <ProtectedRoute>
                                <RoomResult />
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/wallet"
                        element={
                            <ProtectedRoute>
                                <Wallet />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/clan"
                        element={
                            <ProtectedRoute>
                                <Clan />
                            </ProtectedRoute>
                        }
                    />
                </Routes>
            </main>

            {/* Mobile Navbar */}
            {!["/register", "/login"].includes(location.pathname) && <MobileNavbar />
            }


            {/* Footer (login/register sayfalarında gizli) */}
            {!["/register", "/login"].includes(location.pathname) && <Footer />}
        </div>
    );
};

const App = () => {
    return (
        <Suspense fallback={<Loader />}>
            <BrowserRouter>
                <SkeletonTheme baseColor="#202020" highlightColor="#444">
                    <ScrollToTop />
                    <AppContent />
                </SkeletonTheme>
            </BrowserRouter>
        </Suspense>
    );
};

export default App;
